import { useState, useEffect, useCallback } from 'react';
import { useRegularizedContracts } from '../../../hooks/useContracts';
import { usePlans } from '../../../hooks/usePlans';
import { useGroups } from '../../../hooks/useGroups';
import { ITEMS_PER_PAGE } from '../constants/regularizedPlansConstants';

export const useRegularizedPlansTable = () => {
  const { data: plans = [] } = usePlans();
  const { data: groups = [] } = useGroups();

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(ITEMS_PER_PAGE);
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  
  const [filter, setFilter] = useState({
    plan: '',
    group: '',
    contract_number: '',
  });

  useEffect(() => {
    if (plans.length > 0 && !filter.plan) {
      setFilter(prev => ({
        ...prev,
        plan: plans[0].uuid,
      }));
    }
  }, [plans, filter.plan]);

  const queryFilters = {
    ...filter,
    page,
    per_page: rowsPerPage,
  };

  const { 
    data: regularizedResponse, 
    isLoading 
  } = useRegularizedContracts(queryFilters);

  const data = regularizedResponse?.grouped_coupons || [];
  const totalPages = regularizedResponse?.pages || 0;
  const totalCount = regularizedResponse?.total || 0;

  const handleFilter = useCallback((event) => {
    const { name, value } = event.target;
    setFilter(prev => ({
      ...prev,
      [name]: value,
    }));
    setPage(1);
  }, []);

  const handlePageChange = useCallback((event, value) => {
    setPage(value);
  }, []);

  const handleRowsPerPageChange = useCallback((event) => {
    const value = parseInt(event.target.value, 10);
    if (!Number.isNaN(value)) {
      setRowsPerPage(value);
      setPage(1);
    }
  }, []);

  const handleViewDetails = useCallback((item) => {
    setSelectedItem(item);
    setDetailsDialogOpen(true);
  }, []);

  const handleCloseDetailsDialog = useCallback(() => {
    setDetailsDialogOpen(false);
    setSelectedItem(null);
  }, []);

  return {
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    filter,
    
    detailsDialogOpen,
    selectedItem,
    
    plans,
    groups,
    
    handleFilter,
    handlePageChange,
    handleRowsPerPageChange,
    handleViewDetails,
    handleCloseDetailsDialog,
  };
};
